import type { TenantType, UserType } from "~/types/user";

export const useGeneralStore = () => {
  const { public: config } = useRuntimeConfig();
  const tenant = useState<TenantType>('tenant',() => ({} as TenantType));
  const app = useState<AppEnum>('app',() => (AppEnum.EMPTY));
  const user = useState<UserType>('user', () => ({} as UserType));

  const getAppEndpoint = (endpoint: string) => {
    return `${getTenantBaseUrl()}${endpoint}`;
  };

  const getTenantBaseUrl = () => {
    if(!tenant.value.name) tenant.value.name=useTenant();
    return `${config.protocol}://${tenant.value.name?tenant.value.name+'.':''}${config.domain}${config.port?':'+config.port:''}`;
  }

  const setApp = (portal: string) => {
    const item =  Object.values(AppEnum).find((v) => v === portal);
    app.value = item ? item : AppEnum.EMPTY;
  }

  return {
    tenant,
    app,
    user,
    getTenantBaseUrl,
    getAppEndpoint,
    setApp,
  };
};

export enum AppEnum {
  EMPTY = '',
  PROCEDURE = 'procedure',
  AUDIT = 'audit',
  CONTRATTI = 'contratti',
  ACCESSI = 'accessi',
}